import { httpClient } from './httpClient';

export interface Category {
    id: number;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const categoryService = {
    getAllCategories: async () => {
        try {
            return await httpClient.get<Category[]>('/api/categories');
        } catch (error) {
            // Return empty array instead of throwing error when no categories are found
            console.log('Error fetching categories:', error);
            return [];
        }
    },

    getCategoryById: async (id: number) => {
        return httpClient.get<Category>(`/api/categories/${id}`);
    },

    createCategory: async (name: string, description?: string) => {
        return httpClient.post<Category>('/api/categories', { name, description });
    },

    updateCategory: async (id: number, name: string, description?: string) => {
        return httpClient.put<Category>(`/api/categories/${id}`, { name, description });
    },

    deleteCategory: async (id: number) => {
        return httpClient.delete<Category>(`/api/categories/${id}`);
    }
};
